import { StatisticsQueries } from "queries/stat-queries";

export interface Statistics {
    total_revenue: number | null;
    total_products_sold_count: number; // number of products sold
    growth_rate: number; // convert to percentage
    total_orders: number;
    total_30_day_revenue: number; // last 30 days revenue
    revenue_chart: RevenueChart[];
    product_stats: ProductStats[];
    visitors_chart: VisitorsChart[];
    conversion_rate: number;
    average_order_value: number;
}

export interface AdvancedStatistics {
    retention_rate: number;
    geo_distribution: { visitor_cities: { city: string, country: string, count: number }[] };
    customer_lifetime_value: number;
}

export interface PredictiveStatistics {
    revenue_forecast: {
        predicted_revenue: number;
        confidence: string;
        period: string;
    };
    churn_risk: {
        name: string;
        email: string;
        last_order_date: string;
        days_since: number;
    }[];
    seasonal_peaks: {
        period: string;
        impact: string;
        action: string;
    }[];
}


export interface ProductStats {
    name: string;
    price: number;
    category: string;
    image_url: string;
    count: number; // number of times product has sold
}

interface RevenueChart {
    date: string;
    revenue: number;
}

interface VisitorsChart {
    date: string;
    visits: number;
}

export async function getStatisticsAction(timeframe?: string) {
    try {
        const response = await StatisticsQueries.getAllStats(timeframe);
        const data: Statistics = await response.json();

        // console.log(data);

        return { data, status: response.status };
    } catch (err) {
        // console.log(err);
        return null; // Optionally return null or handle the error accordingly
    }
}

export async function getAdvancedStatisticsAction() {
    try {
        const response = await StatisticsQueries.getAdvancedStats();
        const data: AdvancedStatistics = await response.json();
        return { data, status: response.status };
    } catch (err) {
        return null;
    }
}

export async function getPredictiveStatisticsAction() {
    try {
        const response = await StatisticsQueries.getPredictiveStats();
        const data: PredictiveStatistics = await response.json();
        return { data, status: response.status };
    } catch (err) {
        return null;
    }
}
